import { IArgumentType } from '../functions/utils';
import { InferenceError } from '../errors';
import { IFunctionToken } from '../typings/token';
import { isBoolean } from '../utils/type';


// 条件格式固定为：目标对象，比较符和参考值，目标对象/变量可以为变量、常量或函数返回值
export function ELEMENT_MATCH(args: IArgumentType[], token: IFunctionToken) {
  const functionName = token.formatName;

  if (args.length !== 2) {
    throw new InferenceError('function-argument-error', `${functionName} 函数接受两个参数`, token.position);
  }

  const targetArg = args[0];
  const conditionArg = args[1];

  if (!isBoolean(conditionArg)) {
    throw new InferenceError('function-argument-error', `${functionName} 函数第二个参数返回类型必须为布尔类型`, token.position);
  }
  // if (!(conditionArg as any).operator) {
  //   throw new InferenceError('function-argument-error', 'ELEMENT_MATCH 函数的条件参数必须为条件表达式', token.position);
  // }

  return { ...targetArg, isArray: true };
}
